import { JobsOfferListItem } from "./jobs-offer-list-item.model";

export const IJobsSearchList = Object.freeze({
  total: "total",
  jobsOffers: "jobsOffers",
  filteredJobData: "filteredJobData",
  searchParams: "searchParams",
});

export class JobsSearchListModel {
  constructor(data = {}) {
    this[IJobsSearchList.total] = data[IJobsSearchList.total];
    this[IJobsSearchList.jobsOffers] = data[IJobsSearchList.jobsOffers];
    this[IJobsSearchList.filteredJobData] = data[IJobsSearchList.filteredJobData];
    this[IJobsSearchList.searchParams] = data[IJobsSearchList.searchParams];
  }

  getTotal() {
    return parseInt(this[IJobsSearchList.total], 10);
  }

  getJobsOffersList() {
    return (this[IJobsSearchList.jobsOffers] || []).map((offer) => new JobsOfferListItem(offer));
  }

  getFilteredJobData() {
    return this[IJobsSearchList.filteredJobData] || {};
  }

  getParams() {
    return this[IJobsSearchList.searchParams] || {};
  }
}
